/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './applyWrites.defs'
export { main as default } from './applyWrites.defs'
